import { render, staticRenderFns } from "./BrandPartsAttributes.vue?vue&type=template&id=f92877ec&scoped=true&"
import script from "./BrandPartsAttributes.vue?vue&type=script&lang=js&"
export * from "./BrandPartsAttributes.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsAttributes.vue?vue&type=style&index=0&id=f92877ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92877ec",
  null
  
)

export default component.exports